module.exports = __webpack_public_path__ + "static/img/1.8545aea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/4/zh/1.png
// module id = B5ZD
// module chunks = 0